var render = function render(_c,_vm){return _c('div',{staticClass:"zt-block"},[_c('el-row',[_c('el-col',{staticClass:"info-header-item"},[_vm._v("支付方式")]),_c('el-col',{staticClass:"info-body-item"},[_c('div',{staticClass:"pay-type"},[_vm._v("线下支付")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }